(function () {
  const banners = document.querySelectorAll('[data-hal-promo-banner]');

  if (!banners.length) {
    return;
  }

  const storageKeys = {
    dismissedVersion: 'hal_promo_banner_dismissed_version',
    lastSeenVersion: 'hal_promo_banner_last_seen_version',
  };

  function storageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      // Ignore private browsing and blocked storage failures.
    }
  }

  function storageRemove(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      // Ignore private browsing and blocked storage failures.
    }
  }

  function appendFormattedText(parent, text) {
    const pattern = /(\*\*(.+?)\*\*|__(.+?)__|_(.+?)_|~~(.+?)~~|%%(.+?)%%)/g;
    let offset = 0;

    for (const match of text.matchAll(pattern)) {
      if (match.index > offset) {
        parent.append(document.createTextNode(text.slice(offset, match.index)));
      }

      const value = match[2] || match[3] || match[4] || match[5] || match[6] || '';
      let node;

      if (match[2]) {
        node = document.createElement('strong');
      } else if (match[3] || match[4]) {
        node = document.createElement('em');
      } else if (match[5]) {
        node = document.createElement('s');
      } else {
        node = document.createElement('span');
      }

      node.textContent = value;
      parent.append(node);
      offset = match.index + match[0].length;
    }

    if (offset < text.length) {
      parent.append(document.createTextNode(text.slice(offset)));
    }
  }

  function renderMessage(banner) {
    const message = banner.querySelector('[data-hal-promo-banner-message]');
    const text = banner.getAttribute('data-hal-promo-text') || '';

    if (!message) {
      return;
    }

    message.textContent = '';

    text
      .split('|')
      .map((segment) => segment.trim())
      .filter(Boolean)
      .forEach((segment, index) => {
        if (index > 0) {
          const separator = document.createElement('span');
          separator.className = 'hal-promo-banner__separator';
          separator.setAttribute('aria-hidden', 'true');
          separator.textContent = '|';
          message.append(separator);
        }

        const item = document.createElement('span');
        item.className = 'hal-promo-banner__item';
        appendFormattedText(item, segment);
        message.append(item);
      });
  }

  banners.forEach((banner) => {
    const version = banner.getAttribute('data-hal-promo-version') || banner.getAttribute('data-hal-promo-text') || '';
    const closeButton = banner.querySelector('[data-hal-promo-banner-close]');

    renderMessage(banner);

    if (version) {
      const lastSeenVersion = storageGet(storageKeys.lastSeenVersion);
      const dismissedVersion = storageGet(storageKeys.dismissedVersion);

      if (lastSeenVersion !== version) {
        storageRemove(storageKeys.dismissedVersion);
        storageSet(storageKeys.lastSeenVersion, version);
      } else if (dismissedVersion === version) {
        banner.hidden = true;
        return;
      }
    }

    if (!closeButton || !version) {
      return;
    }

    closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      storageSet(storageKeys.lastSeenVersion, version);
      storageSet(storageKeys.dismissedVersion, version);
      banner.classList.add('is-dismissed');

      window.setTimeout(() => {
        banner.hidden = true;
      }, 200);
    });
  });
})();
